export const setLocale =
    (locale = "en") =>
    (dispatch, getState) => {
        if (getState().locale !== locale) {
            dispatch({
                type: "UPDATE_STORE_LOCALE",
                payload: locale,
            });
        }
    };
